export default "__VITE_ASSET__CBEjuChe__$_?url__"